import { ISelectOption, ISelectProps, Select } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import * as React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import SignatureSettings from 'types/enum/SignatureSettings';

export interface ISignatureSettingsSelectProps extends Omit<ISelectProps, 'options' | 'placeholder' | 'onChange'> {
  className?: string | object;
  onChange: (value: SignatureSettings, event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SignatureSettingsSelect = (props: ISignatureSettingsSelectProps) => {
  const { className, onChange, ...selectProps } = props;

  const [t] = useTranslation();

  function onChangeWage(value: string, event: React.ChangeEvent<HTMLSelectElement>) {
    onChange(value as SignatureSettings, event);
  }

  const options = useRef<ISelectOption[]>([
    {
      label: t('Type My Signature'),
      value: SignatureSettings.TYPE_SIGNATURE,
    },
    {
      label: t('Manually Sign'),
      value: SignatureSettings.MANUAL,
    },
  ]);

  const classes = classNames(
    {
      'signature-settings-select': true,
    },
    className
  );

  return (
    <Select
      className={classes}
      placeholder={t('Select')}
      options={options.current}
      onChange={onChangeWage}
      {...selectProps}
    />
  );
};

SignatureSettingsSelect.defaultProps = {
  ...Select.defaultProps,
};

export default SignatureSettingsSelect;
